import { render, staticRenderFns } from "./SmsConfigFolio.vue?vue&type=template&id=0dd01770&"
import script from "./SmsConfigFolio.vue?vue&type=script&lang=js&"
export * from "./SmsConfigFolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports